module.exports = __webpack_public_path__ + "images/category_lp/watch/omega_samples/sec05_sp_c6e0cc853fd30f05452ee558d76484b6.jpg";